import { createActionGroup } from '@ngrx/store';

export const SocieteTerritoireActions = createActionGroup({
  source: 'Societe Territoire',
  events: {}
});
